import { FullHeightContainer } from "./FullHeighContainer.js";
import { Dynamic } from "./dynamic.js";
import { FormGenerator, MetadataNameViewer } from "./formGenerator.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { Config } from "../config/config.js";
import { Commands } from "../util/commandManager.js";
import { LeftDrawerItem, LeftDrawerMenuItem } from "./drawerItems.js";
import { ErrorBoundary } from "../../statistics/components/error_boundary.js";
import { MetaDataHelper } from "../util/metaDataHelper.js";
import { EventType } from "../../../siteManagement/eventManager.js";
import { AdditionalTabInfo, MetadataTab, TabStripProps } from "./tabStrip.js";
import React from "react"
import ReactDOM from "react-dom"
interface ApplicationTabStripState {
    tabs: any[],
    selectedGuid?: string | number,
    selectedTabKey: string;
    isExtended: boolean;
    helpUrl?: any;
}
export class ApplicationTabStrip extends React.Component<TabStripProps, ApplicationTabStripState>{
    private tabstrip: kendo.ui.TabStrip;
    private changedTabs = {};
    private tabStripContentWrapper: JQuery = null;
    private tabsToRender: Array<InternalTab> = [];

    constructor(props) {
        super(props);
        this.tabStripContentWrapper = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();
        this.tabStripContentWrapper.addClass("drawer__content--always-visible");
        if (Config.settings.isMobileApp)
            this.tabStripContentWrapper = General.Sheet.Manager.getTopMostSheet().elements.getToolbarRef();

        const tabsInMetadata = ApplicationTabStrip.internalTabStateFromProps(props);

        this.registerSwitchTabByOutsideCommand();
        const queryParameters = Helper.getQueryStringParameters();
        const tabIdFromUrl = queryParameters["openTab"];
        const state: ApplicationTabStripState = { tabs: tabsInMetadata, isExtended: false, selectedTabKey: null };
        if (tabIdFromUrl) {
            const viaUrlSelectedTab = tabsInMetadata.find(t => t.metadataTab.iskey == tabIdFromUrl);
            state.selectedGuid = viaUrlSelectedTab ? viaUrlSelectedTab.guid : null;
        }
        this.state = state;
    }

    private static internalTabStateFromProps(props: any) {
        const tabsInMetadata = [];
        for (let i = 0; i < props.metadata.tabs.length; i++) {
            const tab: MetadataTab = props.metadata.tabs[i];
            const hasRegions = tab.regions !== undefined && tab.regions !== null && tab.regions.length > 0;
            let reactComponent = null;
            let moduleName = null;
            let appName = null;
            if (Helper.hasValue(tab.component)) {
                reactComponent = tab.component;
            }
            if (Helper.hasValue(tab.moduleName))
                moduleName = tab.moduleName;
            if (Helper.hasValue(tab.appName))
                appName = tab.appName;
            const currTab = {
                guid: props.metadata.tabs[i].guid ? (props.metadata.tabs[i].guid || "") + (moduleName || "") : i,
                hasRegions: hasRegions,
                reactComponent: reactComponent,
                moduleName: moduleName,
                appName: appName,
                props: tab.props,
                hasPlaceholder: tab.hasPlaceholder === true,
                content: null,
                metadataTab: tab,
                propsResolverName: tab.propsResolverName
            };
            tabsInMetadata.push(currTab);
        }
        return tabsInMetadata;
    }

    static getDerivedStateFromProps(props, state) {
        return {
            tabs: ApplicationTabStrip.internalTabStateFromProps(props)
        }
    }

    private registerSwitchTabByOutsideCommand = () => {
        this.props.commandManager.registerExecutor("switchActiveTab", (command, data) => {
            if (command === Commands.DYNAMIC) {
                const nextTabs = this.tabsToRender.filter(f => this.isTabSearchResult(f.metadataTab));
                const nextActiveTab = (nextTabs.filter(f => f.guid == this.state.selectedGuid).length > 0) ? nextTabs.filter(f => f.guid = this.state.selectedGuid)[0] : nextTabs[0]

                this.setState({ selectedGuid: nextActiveTab ? nextActiveTab.guid : null });

            }
        });
    }
    onTabChange = (metadataTab) => {
        this.props.onTabChange(metadataTab);
    }
    private activateTab = (tabIndex: number) => {
       
        const metadataTab = this.tabsToRender[tabIndex].metadataTab;
        
        this.onTabChange(metadataTab);

        const indexInAllTabs = this.state.tabs.findIndex(t => t.metadataTab == metadataTab);
        const activatedTab = this.state.tabs[indexInAllTabs];
        const eventData = { index: indexInAllTabs, firstLoad: !activatedTab.loaded, component: activatedTab.reactComponent, moduleName: activatedTab.moduleName, appName: activatedTab.appName, contentUrl: activatedTab.contentUrl };
        this.state.tabs[indexInAllTabs].loaded = true;

        this.setState({ selectedGuid: activatedTab.guid, selectedTabKey: metadataTab.iskey });

        General.Events.trigger(EventType.Custom, { cmd: "tabStripTabSelected", data: eventData });
        $(window).trigger("tabStripTabSelected", eventData);
    }

    private shouldRenderTab = (tab: MetadataTab): boolean => {
        let isVisible = !((tab.visible !== undefined && tab.visible === false) || (typeof (tab.visible) === "string" && !this.props.handleEval(tab.visible as string)));
        return isVisible;
    }

    private isExtendedView = (tab: MetadataTab) => {
        return ((tab.extendedView !== undefined && tab.extendedView === true) || (typeof (tab.extendedView) === "string" && this.props.handleEval(tab.extendedView as string)));
    }

    private hasExtendedViews = () => {
        return this.props.metadata.tabs.filter(x => this.isExtendedView(x)).length > 0;
    }

    private isTabSearchResult = (tab: MetadataTab): boolean => {
        let countDisplayedRegions = 1;
        if (Array.isArray(tab.regions)) {
            const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
            countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
        }
        return ((countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false));
    }

    public getTabStripRef = () => {
        return this.tabstrip;
    }

    checkTabHasDirtyFields = (tab: InternalTab): boolean => {

        if (!tab.hasRegions) {
            return this.changedTabs[tab.guid] === true;
        }

        for (const region of tab.metadataTab.regions) {
            if (region.fields) {
                for (const field of region.fields) {
                    if (this.props.apphelper && this.props.apphelper.isFieldDirty(field.model)) {
                        return true;
                    }
                }
            }
        }

        return false
    }

    shouldComponentUpdate() {
        if (!this.props.sheet.hasUnsavedChanges()) {
            this.changedTabs = {};
        }
        return true;
    }
    
    componentDidMount() {
        if (this.state.selectedTabKey != this.getSelectedTab()?.metadataTab.iskey)
        {
            this.setState({selectedTabKey: this.getSelectedTab()?.metadataTab.iskey});
            this.props.onTabChange(this.getSelectedTab()?.metadataTab);
        }
    }

    componentDidUpdate(prevProps: Readonly<TabStripProps>, prevState: Readonly<ApplicationTabStripState>, snapshot?: any) {
        const selectedTab = this.getSelectedTab();
        if (Helper.hasValue(selectedTab) && this.state.selectedTabKey != selectedTab.metadataTab.iskey) {
            this.setState({ selectedTabKey: selectedTab.metadataTab.iskey });
            this.props.onTabChange(selectedTab.metadataTab);
        }
    }

    private updateTabs = () => {
        this.tabsToRender = [];
        let lst = [];
        this.props.metadata.tabs.forEach((tab, index) => {
            let countDisplayedRegions = 1;
            if (Array.isArray(tab.regions)) {
                const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
                countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
            }
            if ((countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false)) {
                lst.push({ title: tab.title, index: index });
            }
        });

        this.props.metadata.tabs.forEach((tab, index) => {
            let countDisplayedRegions = 1;
            if (Array.isArray(tab.regions)) {
                const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
                countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
            }

            const condition1 = (countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false);
            const condition2 = lst.length == 0;

            if ((condition1 || condition2) && this.shouldRenderTab(tab) && this.isTabSearchResult(tab)) {
                const tabFromState = this.state.tabs[index];
                tabFromState.useExtendedView = this.isExtendedView(tab);
                this.tabsToRender.push(tabFromState);
            }
        });
    }

    render() {
        const tabContent = [];

        this.updateTabs();

        const selectedTabGuidOrFirstVisibleTab = this.getSelectedTab()?.guid;

        this.state.tabs.forEach((tabFromState, index) => {
            if (tabFromState.hasRegions) { // Regionen          
                tabContent.push(<LazyTabRenderer key={tabFromState.guid || index} tabIsSelected={selectedTabGuidOrFirstVisibleTab === tabFromState.guid}>
                    <div className={"flex-container__item" + (selectedTabGuidOrFirstVisibleTab === tabFromState.guid ? " active" : "")}>
                        <FormGenerator regions={tabFromState.metadataTab.regions}
                            entity={this.props.entity}
                            dataSources={this.props.dataSources}
                            context={this.props.context}
                            onChange={this.props.onChange}
                            onDataLoaded={this.props.onDataLoaded}
                            handleEval={this.props.handleEval}
                            handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            commandManager={this.props.commandManager}
                            debug={this.props.debug}></FormGenerator>
                    </div>
                </LazyTabRenderer>);
            }
            else if (tabFromState.metadataTab.isSaveable) {
                const module = this.props.resolveModule && this.props.resolveModule(tabFromState.moduleName);
                if (module) {
                    tabContent.push(<LazyTabRenderer key={tabFromState.guid || index} tabIsSelected={selectedTabGuidOrFirstVisibleTab === tabFromState.guid}>
                        <div className={"flex-container__item" + (selectedTabGuidOrFirstVisibleTab === tabFromState.guid ? " active" : "")}>
                            {module.GetComponent(this.props.context.keyVal1, this.props.context.keyVal2, tabFromState.metadataTab.props, this.props.entity.RecordRight)}
                        </div>
                    </LazyTabRenderer>);
                }
            }
            else { // React Komponenten
                const props: any = {};
                const propsFromParentApp = this.props.apphelper ? this.props.apphelper.getPropsFromContextByName(tabFromState.metadataTab.propsResolverName) : null;
                $.extend(props, this.props, tabFromState.props, { commandManager: this.props.commandManager }, propsFromParentApp);
                const parentOnChange = this.props.onChange;
                const onChangeWrapper = (p1, p2, p3) => {
                    this.changedTabs[tabFromState.guid || index] = true;
                    parentOnChange(p1, p2, p3);
                }
                props.onChange = onChangeWrapper;
                props.fieldProps = tabFromState.metadataTab;
                tabContent.push(<LazyTabRenderer key={tabFromState.guid || index} tabIsSelected={selectedTabGuidOrFirstVisibleTab === tabFromState.guid}>
                    <div className={"flex-container__item" + (selectedTabGuidOrFirstVisibleTab === tabFromState.guid ? " active" : "")}>
                        <ErrorBoundary>
                            <Dynamic {...props} componentName={tabFromState.reactComponent} moduleName={tabFromState.moduleName} appName={tabFromState.appName} />
                        </ErrorBoundary>
                    </div>
                </LazyTabRenderer>)
            }
        });

        return (
            <FullHeightContainer classes="sheet__tab-pages">
                {ReactDOM.createPortal(
                    <div className="tabstrip__content">
                        {
                            ((this.tabsToRender.length > 1)) ?
                                <>
                                    <label className="section-label">{Config.translations.sections}</label>
                                    {
                                        this.tabsToRender.map((tab, index) => {
                                            if (tab.useExtendedView && !this.state.isExtended)
                                                return;

                                            return this.getTabItem(tab.guid, this.checkTabHasDirtyFields(tab), tab.metadataTab.title, tab.metadataTab.iconName, index,
                                                tab.metadataTab.isSaveable, tab.moduleName, tab.guid == selectedTabGuidOrFirstVisibleTab, tab.metadataTab["iskey"], tab.metadataTab.additionalInfo);
                                        })
                                    }
                                    {this.hasExtendedViews() ?
                                        !Config.settings.isMobileApp ?
                                            <div style={{ color: "#069" }}>
                                                <LeftDrawerItem label={this.state.isExtended ? Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowLess") : Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowMore")}
                                                    icon={this.state.isExtended ? "caret-up" : "caret-down"}
                                                    onClick={() => { this.setState({ isExtended: !this.state.isExtended }) }}
                                                        id="extendedViewApplicationTabstrip" />
                                            </div>
                                            :
                                            <LeftDrawerMenuItem
                                                tabs={this.tabsToRender.filter(x => x.useExtendedView)}
                                                getTabItem={(tab) => {
                                                    const index = this.tabsToRender.findIndex(t => t.metadataTab == tab.metadataTab);
                                                    return this.getTabItem(tab.guid, this.checkTabHasDirtyFields(tab), tab.metadataTab.title, tab.metadataTab.iconName, index,
                                                        tab.metadataTab.isSaveable, tab.moduleName, tab.guid == selectedTabGuidOrFirstVisibleTab, tab.metadataTab["iskey"], tab.metadataTab.additionalInfo);
                                                }}
                                                onClick={(tab: InternalTab) => {
                                                    const index = this.tabsToRender.findIndex(t => t.metadataTab == tab.metadataTab);
                                                    this.activateTab(index);
                                                }}
                                            />
                                        : null
                                    }
                                </>
                                : null
                        }
                    </div>
                    , this.tabStripContentWrapper[0]
                )
                }
                {tabContent}
            </FullHeightContainer>
        );
    }

    private getSelectedTab() {
        const selectedTab = this.tabsToRender.find(t => t.guid == this.state.selectedGuid);
        const defaultFirstTab = (this.tabsToRender.length > 0 ? this.tabsToRender[0] : null);
        return selectedTab ? selectedTab : defaultFirstTab;
    }

    getTabItem = (guid: string | number, hasChages: boolean, title: string, iconName: string, index: number, isSaveable: boolean, moduleName: string, isSelected: boolean, uniqueName: string, additionalTabInfo: AdditionalTabInfo) => {
        if (isSaveable) {
            const module = this.props.resolveModule && this.props.resolveModule(moduleName);
            if (module) {
                //additionaInfo = module.GetMenuItem(() => { });
                hasChages = module.HasChanges();
            }
        }

        return <React.Fragment key={guid}>
            {uniqueName && this.props.debug ? < MetadataNameViewer metadataName={uniqueName} backgroundColor="lightgreen" /> : null}
            <LeftDrawerItem
                key={guid}
                hasChanges={hasChages}
                label={title}
                icon={iconName}
                id={guid.toString()}
                onClick={(e) => {
                    if (Helper.useMobileGui()) {
                        General.Drawer.Left.close();
                    };
                    this.activateTab(index);
                }}
                wrapperClass={isSelected ? "current" : null}
                additionalInfo={additionalTabInfo}
                handleEval={this.props.handleEval}
            />
        </React.Fragment>
    }
};

interface LazyTabRendererProps extends React.PropsWithChildren {
    tabIsSelected: boolean
}

class LazyTabRenderer extends React.Component<LazyTabRendererProps, { renderContent: boolean }>{

    constructor(props: LazyTabRendererProps | Readonly<LazyTabRendererProps>) {
        super(props);
        this.state = { renderContent: props.tabIsSelected };
    }

    componentDidUpdate(prevProps: LazyTabRendererProps) {
        if (!this.state.renderContent && this.props.tabIsSelected) {
            this.setState({ renderContent: true });
        }
    }

    render() {
        return !this.state.renderContent ? null : this.props.children;
    }
}

export interface InternalTab {
    guid: string | number;
    hasRegions: boolean;
    reactComponent: string;
    moduleName: string;
    appName: string;
    props: any;
    hasPlaceholder: boolean;
    content: string;
    metadataTab: MetadataTab;
    useExtendedView: boolean;
}

